function AboutCompany() {
  return (
    <section className="about" id="about">
      <h2>About WaschenNPure</h2>
      <p>
        WaschenNPure is committed to delivering high-quality washing and cleaning
        products that provide powerful stain removal while being gentle on
        fabrics. Our products are designed to ensure freshness, hygiene, and
        long-lasting care for your clothes.
      </p>
      <p>
        Trusted by households and businesses worldwide, WaschenNPure combines
        innovation and quality to make everyday cleaning effortless.
      </p>
    </section>
  );
}

export default AboutCompany;